<template>
  <div class="newsBox wrap" style="max-width:801px;
margin:0 auto;">
    <h2>{{ content.Title }}</h2>
    <h3>
      <span class="tip">{{ content.Type }}</span>
      <span class="time">{{
        this.$moment(content.PubDate).format("YYYY-MM-DD")
      }}</span>
    </h3>
    <p class="newCreater" style="text-align:center;">{{ content.Author }}</p>
    <section class="newsContent" v-html="changeValue(content.Text)"></section>
    <section class="pageBox">
      <div class="Btn" @click="getContent({ Id: Id, Type: 1 })">
        <i class="el-icon-back"></i>
        {{
        lang == "en"
          ? "Previous"
          : "上一条"
      }}
        
      </div>
      <div class="Btn" @click="getContent({ Id: Id, Type: -1 })">
        
        {{
        lang == "en"
          ? "Next"
          : "下一条"
      }}
        <i class="el-icon-right"></i>
      </div>
    </section>
  </div>
</template>

<script>
import { changeText } from "@/utils/tool";
export default {
  data() {
    return {
      content: "", Id: "",
      lang: this.$global.lang,
    };
  },
  methods: {
    getContent(params) {
      this.$api.contentDetailInfo(params).then((res) => {
        // console.log(res)
        this.content = res.Value;
        this.Id = res.Value.Id;
        var element = document.documentElement.scrollTop
          ? document.documentElement
          : document.body;

        element.scrollTop = 0;
      });
    },
    changeValue(value) {
      return changeText(value);
    },
  },
  mounted() {
    const { id } = this.$route.query;
    this.Id = id;
    this.getContent({ Id: id });
  },
};
</script>

<style lang="scss">
.newsBox{

  .newsContent {
    padding: 30px 0;
    border-top: 2px solid #eee;
    border-bottom: 2px solid #eee;
    font-size: 16px;
    line-height:1.8;
  }
  h2 {
    font-weight: 600;
    font-size:24px;
    padding: 30px 0;
    text-align: center;
  }
  h3 {
    text-align: center;
    font-size: 14px;
    .tip {
      color: #d71820;
      padding:3px 6px;
      background: #eee;
      display: inline-block;
      margin-right: 20px;
    }
  }
  .newCreater {
    text-align: right;
    padding: 30px 0;
  }
  .pageBox {
    text-align: center;
    .Btn {
      cursor: pointer;
      margin: 0 15px;
      font-size:16px;
      padding:10px 35px;
    }
  }
}
@media (max-width:750px){
  .newsBox .pageBox .Btn{
    padding:3px 15px;
    font-size:12px;
    margin:0 6px;
  }
}
</style>